/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const DeleteIcon = ({ fill = "#9A9A9A", width = "16", height = "16" }) => {
  return (
    <svg
      viewBox="0 0 13 21"
      fill="none"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      test-id="I0H708pr"
    >
      <path
        d="M12.041 3.04125L4.59852 10.5L12.041 17.9587L9.74977 20.25L-0.000234076 10.5L9.74977 0.75L12.041 3.04125Z"
        fill={fill}
        test-id="FSngzgS6"
      />
    </svg>
  );
};

export default DeleteIcon;
